import React from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, CircularProgress } from "@nextui-org/react";
import { useTranslation } from "react-i18next";
import { BsDatabaseFill } from "react-icons/bs";

import StackedBarChart from "../../../components/charts/StackedBarChart";

const BarChartSection = ({ title, data }) => {
  const { t } = useTranslation();
  const { departments, loading_departments } = useSelector((state) => state.analytics.analytics);

  const sortedDepartments = [...departments].sort((a, b) => b.value - a.value);
  const labels = sortedDepartments.map((dep) => dep.name);
  const chartData = {
    labels,
    green: sortedDepartments.map((dep) => dep.green || 0),
    orange: sortedDepartments.map((dep) => dep.orange || 0),
    red: sortedDepartments.map((dep) => dep.red || 0),
    non_graded: sortedDepartments.map((dep) => dep.non_graded || 0),
  };

  const totalCalls = sortedDepartments.reduce(
    (accumulator, dep) => accumulator + (dep.value || 0),
    0
  );

  return (
    <Card
      className="w-full h-full rounded-md shadow-custom-light px-[32px] py-[20px]"
      shadow="none"
    >
      <CardBody className="w-full p-0 box-border">
        <div className="w-full flex items-center justify-between">
          <h6 className="text-[14px] font-medium text-gray-400 leading-none">{t(title)}</h6>
        </div>
        <div className="flex items-end space-x-1 mt-2">
          {!loading_departments ? (
            <h4 className="text-4xl font-semibold leading-none text-primary">
              {totalCalls === 0 ? "N/A" : totalCalls.toLocaleString("fr-FR")}
            </h4>
          ) : (
            <p className="text-sm text-gray-300">{t("Loading...")}</p>
          )}
          {/* <div className="flex flex-col items-end pl-4">
              <div className="flex items-end w-full text-success">
                <span className=" text-[12px] leading-none font-medium">+2.45</span>
                <IoMdArrowDropup className="w-4 h-4" />
              </div>
              <span className="text-[12px] text-default-300">/ {t("last month")}</span>
            </div> */}
        </div>
        <div className="w-full h-full min-h-[300px] max-h-[460px] overflow-y-auto flex items-start justify-center mx-auto">
          {loading_departments && (
            <div className="flex flex-col justify-center items-center w-full h-96 m-auto text-sm">
              <CircularProgress
                aria-label={t("Loading...")}
                color="primary"
                label={t("Loading...")}
              />
            </div>
          )}
          {!loading_departments && departments.length > 0 && totalCalls > 0 ? (
            <StackedBarChart data={chartData} />
          ) : !loading_departments ? (
            <div className="w-full h-full flex-1 flex flex-col items-center justify-center">
              <BsDatabaseFill className="text-gray-300 w-12 h-12" />
              <h3 className="text-sm text-gray-400 mt-3">{t("No records to display")}</h3>
            </div>
          ) : null}
        </div>
      </CardBody>
    </Card>
  );
};

export default BarChartSection;
